import { queryOptions } from '@tanstack/react-query';
import { listMediaAssets } from './media.service';
import type { MerchantMediaListParams } from './types';

export const mediaQueryKeyPrefix = ['merchant', 'media'] as const;

export function mediaListQueryOptions(params: MerchantMediaListParams) {
  return queryOptions({
    queryKey: [...mediaQueryKeyPrefix, params.page ?? null, params.page_size ?? null],
    queryFn: () => listMediaAssets(params),
    staleTime: 30_000,
  });
}
